import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { ContentLayout12 } from '@components/content/components/content-layout-12/model';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-12',
  imports: [TitleComponent],
  templateUrl: './content-layout-12.component.html',
  styleUrl: './content-layout-12.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout12Component implements OnInit {
  readonly data = input.required<ContentLayout12>();
  title = signal<Title>(null!);

  ngOnInit(): void {
    this.title.set({
      level: 'H2',
      size: {
        mobile: 'H3',
        desktop: 'H3',
      },
      font: 'IVY_MODE',
      color: 'BLACK',
      align: {
        mobile: 'CENTER',
        desktop: 'CENTER',
      },
      text: this.data().title,
    });
  }
}
